<template>
  <Carrusel></Carrusel>
</template>
<script>
import Carrusel from '../carusel'
export default {
  components:{
    Carrusel
  },
  // mounted() {

  //   this.$store.commit('mostrarOcupado', 'Buscando sorteos vigentes...')



  //   setTimeout(() => {
  //       this.$store.commit('ocultarOcupado')
  //       this.$store.dispatch('mostrarMensaje', 
  //       { 
  //         imagen: 'emo-wink',
  //         titulo: 'No se encontraron sorteos',
  //         contenido: 'Parece que no hay sorteos vigentes actualmente.',
  //         boton: {
  //           ruta: { name: 'home' },
  //           etiqueta: 'Regresar al inicio'
  //         }
  //       })
  //   }, 5000);
    
  // }
}
</script>
